import { BaseReducerState} from '../../../services'
import { ActionTypes } from './actions'
import { MonthOverview, AllSitesLedgerAPIResponse } from './types'

export type AllSitesLedgerState = BaseReducerState & {
  data: [MonthOverview]
}

export const initialState: AllSitesLedgerState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const allSitesLedgerState = (
  state: AllSitesLedgerState = initialState,
  action: { type: string; res: any }
): AllSitesLedgerState => {
  switch (action.type) {
    case `${ActionTypes.GET_ALL_SITES_LEDGER_DATA}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.GET_ALL_SITES_LEDGER_DATA}_SUCCESS`: {
      const { success, data, message } = <AllSitesLedgerAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.GET_ALL_SITES_LEDGER_DATA}_FAILURE`:
      const res = <AllSitesLedgerAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.GET_ALL_SITES_LEDGER_DATA}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
